(ns admin.components.composite.question-preview
  (:require
   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.components.base.text :as text]
   [kyber.components.base.icons :as icon]))

(def classes
  (styles->classes
   {:question-preview-container
    {:display :flex
     :flex-direction :column
     :margin-top (gs [:spacing :p12])

     "& > *"
     {:border-bottom (str "1px solid " (gs [:colors :gray-scale-200]))
      :padding-top (gs [:spacing :p12])
      :padding-bottom (gs [:spacing :p12])

      "&:first-child"
      {:padding-top (gs [:spacing :p0])}

      "&:last-child"
      {:border-bottom :none
       :padding-bottom :none}}}

    :answer-label
    {:margin [[(gs [:spacing :p0])
               (gs [:spacing :p12])
               (gs [:spacing :p0])
               (gs [:spacing :p8])]]}

    :choice-container
    {:display :flex
     :align-items :baseline}

    :check-icon
    {:color (gs [:colors :primary-lite-600])
     :padding-right (gs [:spacing :p8])}

    :rating-scale-question-table
    {:width "100%"

     "& th"
     {:padding-bottom (gs [:spacing :p4])
      :padding-top (gs [:spacing :p20])}

     "& th:first-child"
     {:text-align :left}

     "& tr"
     {:border-bottom (str "1px solid " (gs [:colors :gray-scale-200]))}

     "& td"
     {:text-align :center
      :vertical-align :middle}

     "& td:first-child"
     {:text-align :left}}}))

(defn- render-single-multiple-answer-choices
  [{:keys [question show-letters selected-icon unselected-icon]}]
  (let [idx-choices (map-indexed #(assoc %2 :idx %1) (:question/choices question))
        letter-array (vec (map char (range 65 91)))]
    [:div {:class (:question-preview-container classes)}
     (for [{:keys [idx]
            :question.choice/keys [body uuid correct-answer]} idx-choices]
       ^{:key uuid}
       [:div {:class (:choice-container classes)}
        [icon/icon {:class (:check-icon classes)}
         (if correct-answer
           selected-icon
           unselected-icon)]

        (if show-letters
          [:<>
           [text/caption-30 :label
            {:class (:answer-label classes)}
            (str (letter-array (min idx 25))
                 ":")]
           [text/caption-20 :p body]]
          [text/caption-20 :p
           {:class (:answer-label classes)}
           body])

        (when (= uuid "other-option-uuid")
          [:input
            {:style {:margin-left (gs [:spacing :p12])}
             :disabled :true}])])]))

(defn- render-rating-scale-question
  [{:question/keys [choices headers other-enabled]}]
  (let [headers* (cond-> headers
                   other-enabled
                   (into [{:question.header/body "N/A" :question.header/uuid "N/A"}]))]
    [:table {:class (:rating-scale-question-table classes)}
     [:tbody
      [:tr
       [:td ""]
       (for [{:question.header/keys [uuid body]} headers*]
         ^{:key uuid}
         [:td
          [text/caption-30 :p body]])]
      (for [{:question.choice/keys [body uuid]} choices]
        ^{:key uuid}
        [:tr
         [:td
          [text/caption-20 :p body]]
         (for [{:question.header/keys [uuid]} headers*]
           ^{:key uuid}
           [:td
            [icon/icon-sm {:style {:color (gs [:colors :primary-lite-600])}}
             :circle]])])]]))

(defn render
  [{:keys [question]}]
  (let [type (:question/type question)]
    [:div {:class (:question-preview-container classes)}
     (cond
       (= type "single-answer")
       [render-single-multiple-answer-choices {:question question
                                               :show-letters true
                                               :selected-icon :check-circle
                                               :unselected-icon :circle}]

       (= type "multiple-answer")
       [render-single-multiple-answer-choices {:question question
                                               :show-letters false
                                               :selected-icon :check-square
                                               :unselected-icon :square}]

       (= type "rating-scale")
       [render-rating-scale-question question])]))
